<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        Thanks! Linking your account. <br>
                        <span style="display: inline-block;" > {{ellipses}} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import firebase from '../firebase';

  export default {
    name: 'register',
    data() {
      return {
        ellipses: '.'
      }
    },
    mounted() {
      let count = 0;
      setInterval(() => {
          this.ellipses = "...".slice(0, count++ % 4);
      }, 500);

      const stripeAuthenticate = firebase.functions.httpsCallable('stripeAuthenticate');
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const live = process.env.VUE_APP_live === 'true';
      stripeAuthenticate({code, live});
    }
  }
</script>
<style>
</style>
